import { defineStore } from 'pinia';

import type { UnconfiguredGuests } from '~/domains/booking';

type State = {
  _dates: Date[];
  _rooms: UnconfiguredGuests[];
};

type Getters = {
  dates: () => Date[];
  rooms: () => UnconfiguredGuests[];
};

type Actions = {
  setDates: (dates: Date[]) => void;
  setRooms: (rooms: UnconfiguredGuests[]) => void;
};

export const useHotelStore = defineStore<'hotel', State, Getters, Actions>(
  'hotel',
  {
    actions: {
      setDates(dates) {
        this._dates = dates;
      },
      setRooms(rooms) {
        this._rooms = rooms;
      },
    },
    getters: {
      dates() {
        return this._dates;
      },
      rooms() {
        return this._rooms;
      },
    },
    state() {
      return {
        _dates: [],
        _rooms: [],
      };
    },
    persist: {
      storage: persistedState.sessionStorage,
      // @ts-ignore
      afterRestore: (context: any) => {
        if (Array.isArray(context.store.$state._dates)) {
          context.store.$state._dates = context.store.$state._dates.map(
            (date: any) => new Date(date),
          );

          // As the local storage is long term storage, we need to handle it manually
          // If the first date is in the past, clear the dates and rooms
          if (context.store.$state._dates.length > 0) {
            const firstDate = context.store.$state._dates[0];
            const today = new Date();
            if (firstDate < today) {
              context.store.$state._dates = [];
              context.store.$state._rooms = [];
            }
          }
        }
      },
    },
  },
);
